import React from 'react';
import AtlasV2ContentProductGrid from 'src/components/AtlasV2Components/AtlasV2ContentPageComponents/AtlasV2ContentScore/AtlasV2ContentProductGrid';
import AtlasV2ContentTopSection from 'src/components/AtlasV2Components/AtlasV2ContentPageComponents/AtlasV2ContentScore/AtlasV2ContentTopSection';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * Content Score Page in content tab = content, subtab = score
 *
 */
export const AtlasV2ContentScorePageLayout = () => {
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      {/* DONUT CHART and MINI SPLINE CHART and Splint Chart */}
      <AtlasV2ContentTopSection />
      {/* Content Product Grid */}
      <AtlasV2ContentProductGrid />
    </BasePageContainer>
  );
};
